import { state } from '@frameio/graphql-client';
import type { TransferBatch } from '../../types/uploader';
import type { UploadApolloInput } from '../useUploadingApollo';

export const useJobUpdate = () => {
  const jobUpdate = ({ payload }: UploadApolloInput) => {
    const userId = 'default';
    const updatedTime = new Date().toISOString();
    const jobInput = payload.job;
    const userState = state.transfers.transferBatches.get(userId);
    const list = [...userState.batches];

    const indexOfJob = list.findIndex((j) => {
      return j.id === jobInput.id;
    });
    if (indexOfJob === -1)
      return { id: jobInput.id, error: 'job not created yet.' };

    const draftJob = list[indexOfJob];

    const updatedJob: TransferBatch = {
      ...draftJob,
      ...jobInput,
      progress: {
        ...draftJob.progress,
        ...jobInput?.progress,
        id: jobInput.id,
      },
      updatedAt: updatedTime,
    };

    list[indexOfJob] = updatedJob;

    state.transfers.transferBatches.set(userId, {
      batches: list,
      updatedAt: updatedTime,
    });

    return updatedJob;
  };

  return jobUpdate;
};
